import { mapObjectToList } from '../utils';
import { merge } from 'lodash';

const initialState = {
  data: {},
};

const crews = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS': {
      const crew = payload.entities && payload.entities.crews;
      return merge({}, state, { data: crew });
    }
    default:
      return state;
  }
};

export default crews;

export const crewList = state => mapObjectToList(state.data);
export const getById = state => id => state.data[id];



// WEBPACK FOOTER //
// ./client/app/reducers/crews.js